module.exports = __webpack_public_path__ + "img/2012-08-18 13.26.12.2f405ac8.jpg";